import { useQuery } from "@tanstack/react-query";
import { useHostedService } from "./hosted";
import type { SpaceQueries } from "./query";

/**
 * Whether the customer has any app to connect. Preá Nuvem hides the entry until the managed
 * catalog has something in it; a server you run yourself always keeps it.
 */
export function useConnectableApps(queries: SpaceQueries): boolean {
  const hosted = useHostedService();
  const catalog = useQuery({
    ...queries.connections.catalog.queryOptions({ input: {} }),
    enabled: hosted,
  });
  return !hosted || (catalog.data?.length ?? 0) > 0;
}
